<template>
  <div :class="'col-md-' + col">
    <div class="card">
      <div
        class="card__header"
        :style="resumeTitle || resumeTitle === 0 || resumeLink || openingCard || dinamicBody ? 'border-bottom: 1px solid #e6e9ec; padding-bottom: 10px;' : ''">
        <span :title="title" :style="'text-align:' + textAlign">{{ title }}</span>
        <div class="card__arrow" v-if="contentDetailsList">
          <ion-icon @click="openCard()" v-if="openingCard" name="chevron-up-outline"></ion-icon>
          <ion-icon @click="openCard()" v-else name="chevron-down-outline"></ion-icon>
        </div>
      </div>
      <div v-if="dinamicBody" class="card__body">
        <slot/>
      </div>
      <div v-else class="card__body">
        <span v-if="resumeTitle !== ''" class="card__resume">{{ resumeTitle }}</span>
        <span v-if="resumeLink" class="card__resume" style="margin-top: 0;">
          <a :href="resumeLink" :target="resumeTarget">{{ resumeTitleLink }}</a>
        </span>
        <div class="card__list" v-if="openingCard">
          <span v-for="(value, index) in contentDetailsList" :key="index">
            {{ value.name }} <b>{{ value.value }}</b>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "miniCardDetails",
  props: {
    title: {
      required: true,
    },
    dinamicBody: {
      default: false,
    },
    resumeTitle: '',
    resumeLink: '',
    resumeTitleLink: '',
    resumeTarget: '',
    col: {
      required: true,
    },
    openedCard: {
      default: false,
    },
    textAlign: {
      default: ''
    },
    contentDetailsList: '',
  },
  data() {
    return {
      openingCard: this.openedCard,
    }
  },
  methods: {
    openCard(value) {
      this.openingCard = !this.openingCard;
    }
  }
}
</script>

<style lang="scss" scoped>
/* Seletor de bloco */
.card {
  background: #FFFFFF;
  border-radius: 10px !important;
  padding: 20px;
  margin-top: 30px;

  /* Seletor de elemento */
  &__header {
    display: flex;
    align-items: center;

    span {
      font-size: 18px;
      font-weight: 700;
      color: #191919;

      display: list-item;
      width: 100%;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      align-items: center;
    }

    ion-icon {
      font-size: 17px;
      cursor: pointer;
    }
  }

  &__header > &__arrow {
    display: flex;
    align-items: center;
    margin-left: 4px;
  }

  &__body > &__list {
    display: flex;
    flex-direction: column;
    padding-top: 15px;
    margin-top: 20px;
    border-top: 1px solid #E6E9EC;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #191919;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  /* Seletor de elemento */
  &__body > &__resume {
    display: flex;
    justify-content: center;
    margin-top: 15px;
    font-size: 24px;
    font-weight: 700;
    color: #191919;
    transition: .2s;

    a {
      color: #2F23D6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/layouts/miniCardDetails.vue